import axios from 'axios';

import { BASE_URL } from '../../inc/constants';
import {fetchCommoditiesStarted,
  fetchCommoditiesSuccess,
  fetchCommoditiesError, 
  postCommodityStarted, 
  postCommoditySuccess, 
  postCommodityError,
  putCommodityStarted, 
  putCommoditySuccess, 
  putCommodityError,
  deleteCommodityStarted, 
  deleteCommoditySuccess, 
  deleteCommodityError
} from './actions';
import { AppState } from '..';
import { handleCache } from '../base/functions';
import { Commodity } from './types';
import { clone } from '../charts/functions';

export const fetchCommodities = () => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchCommoditiesStarted());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.get(`${BASE_URL}/commodities/`,{headers})
        .then(res => {
          dispatch(fetchCommoditiesSuccess(res.data));
        })
        .catch(err => {
          dispatch(fetchCommoditiesError(err));
          handleCache(dispatch,err);
        });

    };
};

export const postCommodity = (data :any, then?:Function) => {
  return (dispatch :any, getState :Function) => {
    dispatch(postCommodityStarted());
    let state:AppState = getState();
    const headers = {Authorization: `token ${state.base.token}`};
    axios.post(`${BASE_URL}/commodities/`,data, {headers})
    .then(res => {
      dispatch(postCommoditySuccess());
      if(then) then();
    })
    .catch(err => {
      dispatch(postCommodityError());
      handleCache(dispatch,err);
    });
  }
}

export const putCommodity = (id :number, data :any, then?:Function) => {
  return (dispatch :any, getState :Function) => {
    dispatch(putCommodityStarted());
    let state:AppState = getState();
    const headers = {Authorization: `token ${state.base.token}`};
    axios.put(`${BASE_URL}/commodities/${id}/`,data, {headers})
    .then(res => {
      dispatch(putCommoditySuccess());
      if(then) then();
    })
    .catch(err => {
      dispatch(putCommodityError());
      handleCache(dispatch,err);
    });
  }
}

export const deleteCommodity = (id :number, then?:Function) => {
  return (dispatch :any, getState :Function) => {
    dispatch(deleteCommodityStarted());
    let state:AppState = getState();
    const headers = {Authorization: `token ${state.base.token}`};
    axios.delete(`${BASE_URL}/commodities/${id}/`, {headers})
    .then(res => {
      dispatch(deleteCommoditySuccess());
      if(then) then();
    })
    .catch(err => {
      dispatch(deleteCommodityError());
      handleCache(dispatch,err);
    });
  }
}

export const getCommodity = (commodities:Commodity[], id :number) => {
  if(!commodities || !id) return;
  var com = commodities.find((com:Commodity) => {
    return com.id == id
  });
  if(!com) return;
  else return clone(com)
}